<h2 mat-dialog-title>{{ isEdit ? 'Edit' : 'Add' }} Rate Limit Exception</h2>
<div mat-dialog-content>
    <div class="cmn-flex row space-between">
        <mat-form-field class="flex">
            <mat-label>Caller (service account or user)</mat-label>
            <input [(ngModel)]="override.caller" (ngModelChange)="onCallerChanged($event)"
                   [matAutocomplete]="callerAuto" autocomplete="off" matInput required maxlength="256" name="caller">
            <mat-autocomplete #callerAuto="matAutocomplete">
                <!-- Picking an entry fills in the email, which is the token identity the limits key on -->
                <mat-option *ngFor="let option of callerOptions" [value]="option.email">
                    {{ option.name }} ({{ option.email }})
                </mat-option>
            </mat-autocomplete>
            <mat-hint>Search by name or email, or enter the exact identity</mat-hint>
        </mat-form-field>
    </div>
    <div class="cmn-flex row space-between">
        <mat-form-field class="flex">
            <mat-label>Area</mat-label>
            <mat-select [(ngModel)]="override.route_group" name="route_group" required>
                <mat-option *ngFor="let group of routeGroups" [value]="group.value">{{ group.label }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="cmn-flex row space-between limits">
        <mat-form-field class="flex">
            <mat-label>Requests per minute</mat-label>
            <input [(ngModel)]="override.replenish_rate" matInput type="number" min="1" step="1" inputmode="numeric"
                   (keydown)="blockNonDigits($event)" (paste)="blockNonDigitPaste($event)" name="replenish_rate">
            <mat-hint>Blank = default</mat-hint>
        </mat-form-field>
        <mat-form-field class="flex">
            <mat-label>Burst (requests)</mat-label>
            <input [(ngModel)]="override.burst_capacity" matInput type="number" min="1" step="1" inputmode="numeric"
                   (keydown)="blockNonDigits($event)" (paste)="blockNonDigitPaste($event)" name="burst_capacity">
            <mat-hint>Blank = default</mat-hint>
        </mat-form-field>
        <mat-form-field *ngIf="isAlertManager()" class="flex">
            <mat-label>Max alerts per request</mat-label>
            <input [(ngModel)]="override.alert_cap" matInput type="number" min="1" step="1" inputmode="numeric"
                   (keydown)="blockNonDigits($event)" (paste)="blockNonDigitPaste($event)" name="alert_cap">
            <mat-hint>Blank = default</mat-hint>
        </mat-form-field>
    </div>
    <div class="cmn-flex row space-between">
        <mat-form-field class="flex">
            <mat-label>Justification</mat-label>
            <textarea [(ngModel)]="override.justification" matInput required maxlength="1024" rows="3"
                      name="justification"></textarea>
            <mat-hint align="end">{{ override.justification?.length || 0 }} / 1024</mat-hint>
        </mat-form-field>
    </div>
    <div class="cmn-flex row space-between limits">
        <mat-form-field class="flex">
            <mat-label>Ticket</mat-label>
            <input [(ngModel)]="override.ticket" matInput required maxlength="50" name="ticket"
                   placeholder="SCTASK or Jira key">
        </mat-form-field>
        <mat-form-field class="flex">
            <mat-label>Expires on</mat-label>
            <input [(ngModel)]="expiresOn" [matDatepicker]="expiresPicker" [max]="maxExpiresOn" matInput name="expires_on">
            <mat-datepicker-toggle [for]="expiresPicker" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #expiresPicker></mat-datepicker>
            <mat-hint>Blank = no expiry</mat-hint>
        </mat-form-field>
    </div>
    <mat-checkbox [(ngModel)]="override.enabled" name="enabled">Enabled</mat-checkbox>
    <div *ngIf="getValidationError() as error" class="validation-error">{{ error }}</div>
</div>
<mat-dialog-actions class="cmn-flex row space-between">
    <button (click)="save()" [disabled]="!!getValidationError()" color="primary" mat-raised-button>Save</button>
    <button [mat-dialog-close]="false" color="primary" mat-raised-button>Cancel</button>
</mat-dialog-actions>
